import { favoriteService } from '@/services/favorites.service';
export const checkIfFavorite = async (catalogNumber: string) => {
  const data = await favoriteService.checkFavorite(catalogNumber).then((res) => {
    if (res.code === '200') {
      return res.data;
    }
  });
  return data;
};
export const updateFavorite = async (catalogNumber: string | string[], isFav: boolean) => {
  let data;
  if (!isFav) {
    data = await favoriteService.addToFavorite(catalogNumber).then((res) => {
      if (res.code === '200') {
        return res;
      }
    });
  } else {
    data = await favoriteService.removeFavorite(catalogNumber).then((res) => {
      if (res.code === '200') {
        return res;
      }
    });
  }
  return data;
};
